import axios from 'axios';

// URL do proxy online (atualizada)
const API_URL = "https://api.shippix.pt/proxy.php";

// URL do Baselinker API
const BASELINKER_API_URL = "https://api.baselinker.com/connector.php";
const BASELINKER_TOKEN = "8000573-8006817-4Y0BTT1HA4RDFZOIXYL89WX8M68R5QV4D20EANWHMYANMPP69VQBUI43M315JLN8";

export interface BaselinkerOrder {
  order_id: number;
  shop_order_id: number;
  external_order_id: string;
  order_source: string;
  order_source_id: number;
  order_source_info: string;
  order_status_id: number;
  confirmed: boolean;
  date_confirmed: number;
  date_add: number;
  date_in_status: number;
  user_login: string;
  phone: string;
  email: string;
  payment_method: string;
  payment_method_cod: string;
  payment_done: number;
  delivery_method: string;
  delivery_price: number;
  delivery_fullname: string;
  delivery_company: string;
  delivery_address: string;
  delivery_city: string;
  delivery_state: string;
  delivery_postcode: string;
  delivery_country_code: string;
  delivery_country: string;
  products: {
    storage: string;
    storage_id: number;
    order_product_id: number;
    product_id: string;
    variant_id: string;
    name: string;
    attributes: string;
    sku: string;
    price_brutto: number;
    tax_rate: number;
    quantity: number;
    weight: number;
  }[];
  pick_state: number;
  pack_state: number;
}

interface BaselinkerResponse {
  status: string;
  orders?: BaselinkerOrder[];
  error_message?: string;
}

export const ORDER_STATUS_MAP = {
  129970: { name: 'Novos pedidos', color: '#0077da' },
  129971: { name: 'Para enviar', color: '#ea864d' },
  129972: { name: 'Enviado', color: '#22a564' },
  129973: { name: 'Cancelado', color: '#d54839' },
  130111: { name: 'Aguardar pagamento', color: '#f54f4f' },
  130112: { name: 'Pendente MBWAY', color: '#f54f4f' },
  131181: { name: 'Morada incorreta', color: '#f4b04f' },
  131471: { name: 'Por finalizar', color: '#f4b04f' },
  131472: { name: 'Externo Por faturar', color: '#f54f4f' },
  132813: { name: 'Aguardar recolha', color: '#e7f54f' },
  134043: { name: 'Novo - Aguardar', color: '#f00000' },
  134486: { name: 'Ponto Pickup', color: '#f4b04f' },
  137285: { name: 'Reembolsado', color: '#000000' },
  138141: { name: 'Aguardar levantamento', color: '#f4b04f' },
  139156: { name: 'Levantado', color: '#138f13' },
  179976: { name: 'Aguardar Fatura de vendedor', color: '#f4b04f' },
  179977: { name: 'Faturado concluido', color: '#1fbf34' }
} as const;

export type OrderStatus = keyof typeof ORDER_STATUS_MAP;

export const getOrders = async (): Promise<BaselinkerOrder[]> => {
  try {
    const response = await axios.post<BaselinkerResponse>(API_URL, {
      method: 'getOrders',
      parameters: JSON.stringify({
        page: 1,
        limit: 1000,
        get_unconfirmed_orders: false
      })
    });

    if (response.data?.status === 'SUCCESS' && Array.isArray(response.data.orders)) {
      return response.data.orders;
    }

    if (response.data?.status === 'ERROR') {
      throw new Error(response.data.error_message || 'Erro desconhecido');
    }

    throw new Error('Resposta em formato inválido');
  } catch (error) {
    console.error('Erro ao buscar ordens:', error);
    if (axios.isAxiosError(error)) {
      throw new Error(`Erro na requisição: ${error.message}`);
    }
    throw error;
  }
};

export const determineOrderState = (order: BaselinkerOrder): string => {
  const statusId = order.order_status_id;
  return ORDER_STATUS_MAP[statusId as OrderStatus]?.name || 'Status Desconhecido';
};

export const getOrderStatusColor = (statusId: number): string => {
  return ORDER_STATUS_MAP[statusId as OrderStatus]?.color || '#999999';
};
